import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        klarnaPlacement: {
            '#klarna-placement::part(osm-container)': {
                width: '100%',
                display: 'flex',
                border: 'none',
                backgroundColor: 'background.default',
                alignItems: 'flex-start',
                gap: remCalc(4),
                textAlign: 'left',
                padding: 'unset',
                margin: 'unset',
            },
            '#klarna-placement::part(osm-message)': {
                textStyle: 'body-small',
                color: 'text.default',
                fontWeight: 'normal',
                _hover: {
                    textDecoration: 'none',
                },
                _focus: {
                    boxShadow: 'outline',
                },
            },
            '#klarna-placement::part(osm-cta)': {
                textStyle: 'body-xsmall',
                color: 'text.default',
                fontWeight: 'normal',
                id: 'klarna-cta-link',
                position: 'relative',
                bottom: remCalc(1),
            },
            '#klarna-placement::part(osm-legal)': {
                display: 'none',
            },
        },
    },
    variants: {
        cart: {
            klarnaPlacement: {
                '#klarna-placement::part(osm-container)': {
                    display: 'unset',
                    width: '100%',
                    backgroundColor: 'transparent',
                    height: 'unset',
                    padding: 'unset',
                    borderRadius: 'unset',
                    border: 'unset',
                    borderStyle: 'unset',
                    borderColor: 'unset',
                    alignItems: 'unset',
                    gap: 'unset',
                },
                '#klarna-placement::part(osm-message)': {
                    color: 'text.default',
                    textStyle: 'body-xsmall',
                },
                '#klarna-placement::part(osm-cta)': {color: 'text.light'},
                '#klarna-placement::part(osm-badge-container)': {display: 'none'},
            },
        },
    },
}
